// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__m8ZyA","content":"Banner_content__gfRAl"};